import { render, staticRenderFns } from "./CompanyCampaignCohort.vue?vue&type=template&id=26561f48&scoped=true"
import script from "./CompanyCampaignCohort.vue?vue&type=script&lang=js"
export * from "./CompanyCampaignCohort.vue?vue&type=script&lang=js"
import style0 from "./CompanyCampaignCohort.vue?vue&type=style&index=0&id=26561f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26561f48",
  null
  
)

export default component.exports